// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import { fetchPartialEventUrl } from "../../utils/constants/urls";
import {
  FETCH_PARTIAL_EVENTS_FAILURE,
  FETCH_PARTIAL_EVENTS_REQUEST,
  FETCH_PARTIAL_EVENTS_SUCCESS,
} from "../constants/partialRequests";

export const fetchPartialEventsAction = ({
  payload,
  params,
  successCallback,
  additionalData,
}) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_PARTIAL_EVENTS_REQUEST,
      payload: additionalData,
    });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `${fetchPartialEventUrl(payload.role)}`,
      params,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_PARTIAL_EVENTS_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_PARTIAL_EVENTS_FAILURE });
    }
  };
};